// extracted by mini-css-extract-plugin
module.exports = {"controls":"Controls_controls__1ux0n","button":"Controls_button__3d7Uz"};